import axios from "axios";

//Bootcamp live constants
// export const appname = 'bootcamp';
// export const apiUrl = 'https://users-bootcamp-live.bodyprocoach.com';
// export const rzpKey = 'rzp_live_CPP9cTVJFe1gbY';
// export const typeId  = '10'

//Sweat live constants
export const appname = "sweat";
export const apiUrl = "https://users-api-live.bodyprocoach.com";
export const adminapiUrl = 'https://admin-node-live.bodyprocoach.com/admin';
export const rzpKey = "rzp_live_CPP9cTVJFe1gbY";
export const typeId = "5";

// //testing constants
// export const appname = 'sweat';
// export const apiUrl = 'https://users-api.bodyprocoach.com';
// export const adminapiUrl = 'https://admin-api.bodyprocoach.com/admin';
// export const rzpKey = 'rzp_test_lU4yfoyxNksgdR';
// export const typeId  = '4'

// export const rzpKey = 'rzp_live_CPP9cTVJFe1gbY';
//

export const handleCoupon = async (
  couponcode,
  amountforcoupon,
  planidforcoupon,
  ogvalues,
  DataStore,
  coinsValue,
  params,
  token, 
) => {
  try {
//resolved

    // alert("coins value", JSON.stringify(coinsValue));

    console.log(params, couponcode);

    const couponRequestConfig = {
      params: {
        category_id : params?.category_id,
        cart_amount : params?.cart_amount,
        payment_type: params?.payment_type,
        // plan_id: params?.plan_id,
        session_id: params?.session_id,
        branch_id: params?.branch_id,
        user_id: params?.user_id,
        coupon_code: couponcode
      },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    };

    const response = await axios.get(
      //  `${apiUrl}/checkcoupon.php?coupon=${couponcode}&amount=${amountforcoupon}&plan=${planidforcoupon}`,
      //  "https://api.bodyprocoach.com/checkcoupon.php?coupon=" +
      //   couponcode +
      //   "&amount=" +
      //   amountforcoupon +
      //   "&plan=" +
      //   planidforcoupon,
      //   "Content-Type": "application/json",

      apiUrl + '/get_all_coupons',
      couponRequestConfig
    );
//discount --> applicableDiscount

    console.log("Apply coupon response ", response);

    if (response.status === 200) {
      return {
        error: null,
        data: {
          couponcost: response.data.data[0].applicableDiscount,
          Discount: response.data.data[0].applicableDiscount,
          Taxes:
            parseInt(coinsValue) > 0 ||
            parseInt(response.data.data[0].applicableDiscount) > 0
              ? Math.round(
                  ((ogvalues.Amount -
                    response.data.data[0].applicableDiscount -
                    parseInt(coinsValue)) *
                    DataStore.taxpercent) /
                    100
                )
              : ogvalues?.Taxes,
          total:
            parseInt(coinsValue) > 0 ||
            parseInt(response.data.data[0].applicableDiscount) > 0
              ? Math.round(
                  ogvalues.Amount -
                    response.data.data[0].applicableDiscount -
                    parseInt(coinsValue) +
                    ((ogvalues.Amount -
                      response.data.data[0].applicableDiscount -
                      parseInt(coinsValue)) *
                      DataStore.taxpercent) /
                      100
                )
              : ogvalues.Total,
          ogTaxes: DataStore?.ogTaxes,
          ogTotal: DataStore?.ogTotal,
          couponcode: response.data.data[0].couponcode, //removed coupondata
          couponid: response.data.data[0].uid, 
          couponDetails: response?.data.data
        },
      };
    }
  } catch (error) {
    console.log("Apply coupon error --> ", error);

    //Changed No data found to No coupons found and data.error to data.message

    if (error.response.data.message == "No coupons found") {
      return {
        error: false,
        data: {
          // couponcost: 0,
          // Discount: 0,
          Taxes:
            parseInt(coinsValue) > 0
              ? Math.round(
                  ((ogvalues.Amount - parseInt(coinsValue)) *
                    DataStore.taxpercent) /
                    100
                )
              : DataStore.ogTaxes,
          total:
            parseInt(coinsValue) > 0
              ? Math.round(
                  ogvalues.Amount -
                    parseInt(coinsValue) +
                    ((ogvalues.Amount - parseInt(coinsValue)) *
                      DataStore.taxpercent) /
                      100
                )
              : DataStore.ogTotal,
          ogTaxes: DataStore.ogTaxes,
          ogTotal: DataStore.ogTotal,
          couponcode: null,
          couponid: null,
          notFoundErr: true,
          errMessage: error.response.data.message
        },
      };
    } else {
      return {
        error: error.response.data.error,
        data: {
          // couponcost: 0,
          // Discount: 0,
          Taxes: DataStore.ogTaxes,
          total: DataStore.ogTotal,
          ogTaxes: DataStore.ogTaxes,
          ogTotal: DataStore.ogTaxes,
          couponcode: null,
          couponid: null,
        },
        notFoundErr: false,
        errMessage: error.response.data.message
      };
    }
  }
};

//handle coins function--------

export const calculateUsableReward = async ({
  maxUsableRewardCoins,
  totalUserRewardCoins,
  coinConversionRate,
}) => {
  if (maxUsableRewardCoins <= totalUserRewardCoins) {
    var retdata = [
      parseInt(maxUsableRewardCoins),
      parseInt(maxUsableRewardCoins * coinConversionRate),
    ];
  } else {
    var retdata = [
      parseInt(totalUserRewardCoins),
      parseInt(totalUserRewardCoins * coinConversionRate),
    ];
  }
  return retdata;
};

export const handleCoins = async (
  couponcode,
  amountforcoupon,
  planidforcoupon,
  ogvalues,
  DataStore,
  coinsValue
) => { 
  try {
    
    if (!isNaN(coinsValue)) {
      let mydiscount = isNaN(DataStore.Discount) ? 0 : DataStore.Discount;
      console.log(parseInt(coinsValue) > 0 || parseInt(mydiscount) > 0
    ? Math.round(
        ((DataStore.Amount -
          parseInt(coinsValue) -
          parseInt(mydiscount)) *
          DataStore.taxpercent) /
          100
      )
    : DataStore.ogTaxes,"coinResult243")
      return {
        error: null,
        data: {
          Taxes:
            parseInt(coinsValue) > 0 || parseInt(mydiscount) > 0
              ? Math.round(
                  ((DataStore.Amount -
                    parseInt(coinsValue) -
                    parseInt(mydiscount)) *
                    DataStore.taxpercent) /
                    100
                )
              : DataStore.ogTaxes,
          total:
            parseInt(coinsValue) > 0 || parseInt(mydiscount) > 0
              ? Math.round(
                  DataStore.Amount -
                    parseInt(coinsValue) -
                    parseInt(mydiscount) +
                    ((DataStore.Amount -
                      parseInt(coinsValue) -
                      parseInt(mydiscount)) *
                      DataStore.taxpercent) /
                      100
                )
              : DataStore.ogTotal,
          ogTaxes: DataStore.ogTaxes,
          ogTotal: DataStore.ogTotal,
          couponcost: parseInt(mydiscount),
          Discount: parseInt(mydiscount),
          couponcode: DataStore.couponcode,
          couponid: DataStore.couponid,
          couponDetails: DataStore.couponDetails,
        },
      };
    }
  } catch (error) {
    console.log(error);
  }
};

export const createOrder = async (bodyData2) => {
  try {
    const response2 = await axios.post(`${apiUrl}/createOrder`, bodyData2, {
      headers: { "Content-Type": "application/json" },
    });

    return response2.data.data;
  } catch (error) {
    throw error;
  }
};

export const catUID = async (pathname) => {
  try {
      // Extracting part between the first and second slashes
      const parts = pathname.split('/').filter(Boolean); // Remove empty strings
      const targetSlug = parts[0]; // This grabs the desired slug part

      // API call
      const response = await axios.get(adminapiUrl+'/read_allbranch_alltypes_allplans');
      console.log(response,targetSlug,"catfetcj")
      // Find matching slug in data.All_categories
      const categories = response.data.data.All_categories;
      const match = categories.find(category => category.slug === targetSlug);
      console.log(match,"catfetcj")

      return match ? match.uid : null;
  } catch (error) {
      console.error("Error fetching UID:", error);
      return null;
  }
};
